export const keywordCategoryMap = {
  // #region Житло та нерухомість
  "нерухомість": "Житло та нерухомість",
  "житло": "Житло та нерухомість",
  "житлова": "Житло та нерухомість",
  "будинок": "Житло та нерухомість",
  "приватний будинок": "Житло та нерухомість",
  "котедж": "Житло та нерухомість",
  "дача": "Житло та нерухомість",
  "таунхаус": "Житло та нерухомість",
  "таунхауси": "Житло та нерухомість",
  "дуплекс": "Житло та нерухомість",
  "пентхаус": "Житло та нерухомість",
  "квартира": "Житло та нерухомість",
  "квартира студія": "Житло та нерухомість",
  "студія": "Житло та нерухомість",
  "однокімнатна": "Житло та нерухомість",
  "двокімнатна": "Житло та нерухомість",
  "трикімнатна": "Житло та нерухомість",
  "багатокімнатна": "Житло та нерухомість",
  "кімната": "Житло та нерухомість",
  "кімнати": "Житло та нерухомість",
  "гуртожиток": "Житло та нерухомість",
  "житловий комплекс": "Житло та нерухомість",
  "жк": "Житло та нерухомість",
  "новобудова": "Житло та нерухомість",
  "новобудови": "Житло та нерухомість",
  "новобуд": "Житло та нерухомість",
  "вторинне житло": "Житло та нерухомість",
  "вторинка": "Житло та нерухомість",
  "елітне житло": "Житло та нерухомість",
  "мансарда": "Житло та нерухомість",
  "балкон": "Житло та нерухомість",
  "лоджія": "Житло та нерухомість",
  "тераса": "Житло та нерухомість",
  "поверх": "Житло та нерухомість",
  "поверховість": "Житло та нерухомість",
  "перший поверх": "Житло та нерухомість",
  "останній поверх": "Житло та нерухомість",
  "цоколь": "Житло та нерухомість",
  "паркомісце": "Житло та нерухомість",
  "паркінг": "Житло та нерухомість",
  "гараж": "Житло та нерухомість",
  "гаражі": "Житло та нерухомість",
  "комерційна нерухомість": "Житло та нерухомість",
  "офіс": "Житло та нерухомість",
  "офіси": "Житло та нерухомість",
  "склад": "Житло та нерухомість",
  "склади": "Житло та нерухомість",
  "магазин": "Житло та нерухомість",
  "торгове приміщення": "Житло та нерухомість",
  "приміщення": "Житло та нерухомість",
  "нежитлове приміщення": "Житло та нерухомість",
  "бізнес центр": "Житло та нерухомість",
  "готель": "Житло та нерухомість",
  "хостел": "Житло та нерухомість",
  "кафе": "Житло та нерухомість",
  "ресторан": "Житло та нерухомість",
  "ділянка": "Житло та нерухомість",
  "земельна ділянка": "Житло та нерухомість",
  "будівельна ділянка": "Житло та нерухомість",
  "дачна ділянка": "Житло та нерухомість",
  "участок": "Житло та нерухомість",
  "пай": "Житло та нерухомість",
  "пайова земля": "Житло та нерухомість",
  "сільгосп земля": "Житло та нерухомість",
  "аграрна земля": "Житло та нерухомість",
  "сад": "Житло та нерухомість",
  "сотки": "Житло та нерухомість",
  "гектар": "Житло та нерухомість",
  "житловий фонд": "Житло та нерухомість",
  "нерухомий": "Житло та нерухомість",
  "площа": "Житло та нерухомість",
  "м²": "Житло та нерухомість",
  "м2": "Житло та нерухомість",
  "квадратура": "Житло та нерухомість",
  "квадратний метр": "Житло та нерухомість",
  "житлова площа": "Житло та нерухомість",
  "корисна площа": "Житло та нерухомість",
  "будова": "Житло та нерухомість",
  "підвал": "Житло та нерухомість",
  "цегляний будинок": "Житло та нерухомість",
  "панельний будинок": "Житло та нерухомість",
  "моноліт": "Житло та нерухомість",
  "сервітут": "Житло та нерухомість",
  "власність": "Житло та нерухомість",
  // #endregion

  // #region Транспорт
  "транспорт": "Транспорт",
  "авто": "Транспорт",
  "автомобіль": "Транспорт",
  "машина": "Транспорт",
  "автівка": "Транспорт",
  "легковик": "Транспорт",
  "вантажівка": "Транспорт",
  "грузовик": "Транспорт",
  "мікроавтобус": "Транспорт",
  "бус": "Транспорт",
  "бусік": "Транспорт",
  "автобус": "Транспорт",
  "мінівен": "Транспорт",
  "караван": "Транспорт",
  "кемпер": "Транспорт",
  "будинок на колесах": "Транспорт",
  "автодім": "Транспорт",
  "трицикл": "Транспорт",
  "трайк": "Транспорт",
  "квадроцикл": "Транспорт",
  "квадрик": "Транспорт",
  "баггі": "Транспорт",
  "снігохід": "Транспорт",
  "мотосани": "Транспорт",
  "скутер": "Транспорт",
  "електроскутер": "Транспорт",
  "мотоцикл": "Транспорт",
  "мото": "Транспорт",
  "байк": "Транспорт",
  "самокат": "Транспорт",
  "електросамокат": "Транспорт",
  "моноколесо": "Транспорт",
  "гіроскутер": "Транспорт",
  "гіроцикл": "Транспорт",
  "гіроборд": "Транспорт",
  "електрокар": "Транспорт",
  "електромобіль": "Транспорт",
  "електроавто": "Транспорт",
  "велосипед": "Транспорт",
  "ровер": "Транспорт",
  "електровелосипед": "Транспорт",
  "електровел": "Транспорт",
  "електромопед": "Транспорт",
  "водний скутер": "Транспорт",
  "гідроцикл": "Транспорт",
  "яхта": "Транспорт",
  "катер": "Транспорт",
  "лодка": "Транспорт",
  "човен": "Транспорт",
  "пікап": "Транспорт",
  "седан": "Транспорт",
  "купе": "Транспорт",
  "хетчбек": "Транспорт",
  "універсал": "Транспорт",
  "кабріолет": "Транспорт",
  "кросовер": "Транспорт",
  "паркетник": "Транспорт",
  "джип": "Транспорт",
  "позашляховик": "Транспорт",
  "лімузин": "Транспорт",
  "трейлер": "Транспорт",
  "транспортер": "Транспорт",
  "фура": "Транспорт",
  "тягач": "Транспорт",
  "рефрижератор": "Транспорт",
  "автопоїзд": "Транспорт",
  "цистерна": "Транспорт",
  "зил": "Транспорт",
  "газель": "Транспорт",
  "уаз": "Транспорт",
  "камаз": "Транспорт",
  "маз": "Транспорт",
  // #endregion

  // #region Гаджети
  "гаджети": "Гаджети",
  "електроніка": "Гаджети",
  "смартфон": "Гаджети",
  "телефон": "Гаджети",
  "айфон": "Гаджети",
  "iphone": "Гаджети",
  "андроїд": "Гаджети",
  "android": "Гаджети",
  "ноутбук": "Гаджети",
  "лептоп": "Гаджети",
  "macbook": "Гаджети",
  "макбук": "Гаджети",
  "планшет": "Гаджети",
  "ipad": "Гаджети",
  "телевізор": "Гаджети",
  "tv": "Гаджети",
  "монітор": "Гаджети",
  "екран": "Гаджети",
  "пк": "Гаджети",
  "комп'ютер": "Гаджети",
  "комп’ютер": "Гаджети",
  "системник": "Гаджети",
  "материнка": "Гаджети",
  "відеокарта": "Гаджети",
  "камера": "Гаджети",
  "фотоапарат": "Гаджети",
  "навушники": "Гаджети",
  "airpods": "Гаджети",
  "смарт годинник": "Гаджети",
  "смарт-годинник": "Гаджети",
  "фітнес-браслет": "Гаджети",
  "зарядка": "Гаджети",
  "блок живлення": "Гаджети",
  "модем": "Гаджети",
  "роутер": "Гаджети",
  "хаб": "Гаджети",
  "usb": "Гаджети",
  "жорсткий диск": "Гаджети",
  "ssd": "Гаджети",
  // #endregion

  // #region Карʼєра
  "робота": "Карʼєра",
  "вакансія": "Карʼєра",
  "вакансії": "Карʼєра",
  "працевлаштування": "Карʼєра",
  "заробіток": "Карʼєра",
  "офіційна робота": "Карʼєра",
  "неофіційна робота": "Карʼєра",
  "повна зайнятість": "Карʼєра",
  "часткова зайнятість": "Карʼєра",
  "фріланс робота": "Карʼєра",
  "тимчасова робота": "Карʼєра",
  "дистанційна робота": "Карʼєра",
  "віддалена робота": "Карʼєра",
  "робота на дому": "Карʼєра",
  "робота для студентів": "Карʼєра",
  "робота без досвіду": "Карʼєра",
  "резюме": "Карʼєра",
  "шукаю роботу": "Карʼєра",
  "шукаю підробіток": "Карʼєра",
  "стажування": "Карʼєра",
  "офер": "Карʼєра",
  "зарплата": "Карʼєра",
  "кур'єр": "Карʼєра",
  "будівельник": "Карʼєра",
  "менеджер": "Карʼєра",
  "продавець": "Карʼєра",
  "кадровик": "Карʼєра",
  "касир": "Карʼєра",
  "водій": "Карʼєра",
  "офіціант": "Карʼєра",
  "адміністратор": "Карʼєра",
  "оператор": "Карʼєра",
  "програміст": "Карʼєра",
  "розробник": "Карʼєра",
  "дизайнер": "Карʼєра",
  "аналітик": "Карʼєра",
  "бухгалтер": "Карʼєра",
  "інженер": "Карʼєра",
  "медсестра": "Карʼєра",
  "перекладач": "Карʼєра",
  // #endregion

  // #region Майстри та послуги
  "послуги": "Майстри та послуги",
  "майстер": "Майстри та послуги",
  "надаю послуги": "Майстри та послуги",
  "виконаю": "Майстри та послуги",
  "зроблю": "Майстри та послуги",
  "виїзд": "Майстри та послуги",
  "портфоліо": "Майстри та послуги",
  "прайс": "Майстри та послуги",
  // ремонт/будівництво
  "ремонт": "Майстри та послуги",
  "ремонт квартир": "Майстри та послуги",
  "ремонт будинків": "Майстри та послуги",
  "покрівля": "Майстри та послуги",
  "штукатурка": "Майстри та послуги",
  "маляр": "Майстри та послуги",
  "зварювальні роботи": "Майстри та послуги",
  "зварювальник": "Майстри та послуги",
  "демонтаж": "Майстри та послуги",
  "збірка меблів": "Майстри та послуги",
  "електрик": "Майстри та послуги",
  "сантехнік": "Майстри та послуги",
  "плиточник": "Майстри та послуги",
  "плиточні роботи": "Майстри та послуги",
  "вікна двері монтаж": "Майстри та послуги",
  "укладка плитки": "Майстри та послуги",
  // it/креатив/маркетинг
  "веб-дизайн": "Майстри та послуги",
  "розробка сайтів": "Майстри та послуги",
  "smm": "Майстри та послуги",
  "маркетинг": "Майстри та послуги",
  "seo": "Майстри та послуги",
  "копірайтер": "Майстри та послуги",
  "фотограф": "Майстри та послуги",
  "відеооператор": "Майстри та послуги",
  "відеограф": "Майстри та послуги",
  "монтаж відео": "Майстри та послуги",
  "дизайн інтер'єру": "Майстри та послуги",
  // юридичні/фінансові
  "бухгалтерські послуги": "Майстри та послуги",
  "юридичні послуги": "Майстри та послуги",
  "адвокат": "Майстри та послуги",
  "юрист": "Майстри та послуги",
  "нотаріус": "Майстри та послуги",
  "реєстрація фоп": "Майстри та послуги",
  // освіта/психологія/медицина
  "психолог": "Майстри та послуги",
  "психотерапевт": "Майстри та послуги",
  "логопед": "Майстри та послуги",
  "репетитор": "Майстри та послуги",
  "коуч": "Майстри та послуги",
  "ментор": "Майстри та послуги",
  "лікар приватно": "Майстри та послуги",
  "масаж": "Майстри та послуги",
  "масажист": "Майстри та послуги",
  // краса
  "візажист": "Майстри та послуги",
  "перукар": "Майстри та послуги",
  "барбер": "Майстри та послуги",
  "манікюр": "Майстри та послуги",
  "педикюр": "Майстри та послуги",
  "лешмейкер": "Майстри та послуги",
  "бровист": "Майстри та послуги",
  "косметолог": "Майстри та послуги",
  // побут
  "комп'ютерна допомога": "Майстри та послуги",
  "налаштування інтернету": "Майстри та послуги",
  "клінінг": "Майстри та послуги",
  "прибирання": "Майстри та послуги",
  "хімчистка": "Майстри та послуги",
  "доставка": "Майстри та послуги",
  "кур'єр послуги": "Майстри та послуги",
  "ведучий": "Майстри та послуги",
  "няня послуги": "Майстри та послуги",
  // #endregion

   // #region Дім та затишок
  "дім": "Дім та затишок",
  "меблі": "Дім та затишок",
  "шафа": "Дім та затишок",
  "ліжко": "Дім та затишок",
  "диван": "Дім та затишок",
  "тумба": "Дім та затишок",
  "стіл": "Дім та затишок",
  "стільці": "Дім та затишок",
  "кухонні меблі": "Дім та затишок",
  "гарнітур": "Дім та затишок",
  "комод": "Дім та затишок",
  "техніка для дому": "Дім та затишок",
  "пилосос": "Дім та затишок",
  "мікрохвильовка": "Дім та затишок",
  "чайник": "Дім та затишок",
  "пральна машина": "Дім та затишок",
  "холодильник": "Дім та затишок",
  "посудомийка": "Дім та затишок",
  "декор": "Дім та затишок",
  "свічки": "Дім та затишок",
  "торшер": "Дім та затишок",
  "картини": "Дім та затишок",
  "дзеркало": "Дім та затишок",
  "інтер'єр": "Дім та затишок",
  "будівництво": "Дім та затишок",
  // #endregion

  // #region Для саду та подвір'я
  "сад": "Для саду та подвір'я",
  "рослини": "Для саду та подвір'я",
  "квіти": "Для саду та подвір'я",
  "горщики": "Для саду та подвір'я",
  "саджанці": "Для саду та подвір'я",
  "інструменти": "Для саду та подвір'я",
  "дрель": "Для саду та подвір'я",
  "перфоратор": "Для саду та подвір'я",
  "газонокосарка": "Для саду та подвір'я",
  "шланг": "Для саду та подвір'я",
  "бочка": "Для саду та подвір'я",
  "душ": "Для саду та подвір'я",
  // #endregion

  // #region Малеча
  "для дітей": "Малеча",
  "дитина": "Малеча",
  "дитячий": "Малеча",
  "дитячі речі": "Малеча",
  "дитячий одяг": "Малеча",
  "дитячий одяг для хлопчиків": "Малеча",
  "дитячий одяг для дівчаток": "Малеча",
  "одяг для немовлят": "Малеча",
  "повзунки": "Малеча",
  "боді": "Малеча",
  "сліпони": "Малеча",
  "взуття дитяче": "Малеча",
  "іграшки": "Малеча",
  "мʼякі іграшки": "Малеча",
  "розвиваючі іграшки": "Малеча",
  "конструктор": "Малеча",
  "lego": "Малеча",
  "візочок": "Малеча",
  "коляска": "Малеча",
  "люлька": "Малеча",
  "автокрісло": "Малеча",
  "стільчик для годування": "Малеча",
  "манеж": "Малеча",
  "дитячі меблі": "Малеча",
  "дитяче ліжко": "Малеча",
  "пеленальний стіл": "Малеча",
  "гірка": "Малеча",
  "пісочниця": "Малеча",
  "дитячі книжки": "Малеча",
  "розмальовки": "Малеча",
  "розвиваючі матеріали": "Малеча",
  "шкільне приладдя": "Малеча",
  "рюкзак дитячий": "Малеча",
  // #endregion

  // #region Домашні улюбленці
  "тварини": "Домашні улюбленці",
  "собака": "Домашні улюбленці",
  "собаки": "Домашні улюбленці",
  "пес": "Домашні улюбленці",
  "щеня": "Домашні улюбленці",
  "цуценя": "Домашні улюбленці",
  "кіт": "Домашні улюбленці",
  "кішка": "Домашні улюбленці",
  "котики": "Домашні улюбленці",
  "кошеня": "Домашні улюбленці",
  "птахи": "Домашні улюбленці",
  "папуга": "Домашні улюбленці",
  "папужка": "Домашні улюбленці",
  "хвилястий папуга": "Домашні улюбленці",
  "акваріум": "Домашні улюбленці",
  "риби": "Домашні улюбленці",
  "рибки": "Домашні улюбленці",
  "гризуни": "Домашні улюбленці",
  "хом’як": "Домашні улюбленці",
  "морська свинка": "Домашні улюбленці",
  "шиншила": "Домашні улюбленці",
  "кролик": "Домашні улюбленці",
  "черепаха": "Домашні улюбленці",
  "вуж": "Домашні улюбленці",
  "ящірка": "Домашні улюбленці",
  "коза": "Домашні улюбленці",
  "кури": "Домашні улюбленці",
  "качки": "Домашні улюбленці",
  "свиня": "Домашні улюбленці",
  "коні": "Домашні улюбленці",
  "індик": "Домашні улюбленці",
  "порося": "Домашні улюбленці",
  "аксесуари для тварин": "Домашні улюбленці",
  "корм": "Домашні улюбленці",
  "повідок": "Домашні улюбленці",
  "будка": "Домашні улюбленці",
  "туалет для кота": "Домашні улюбленці",
  "котячий лоток": "Домашні улюбленці",
  // #endregion

  // #region Стиль
  "мода": "Стиль",
  "одяг": "Стиль",
  "взуття": "Стиль",
  "джинси": "Стиль",
  "штани": "Стиль",
  "спідниця": "Стиль",
  "сукня": "Стиль",
  "плаття": "Стиль",
  "блузка": "Стиль",
  "сорочка": "Стиль",
  "футболка": "Стиль",
  "толстовка": "Стиль",
  "светр": "Стиль",
  "куртка": "Стиль",
  "пальто": "Стиль",
  "піджак": "Стиль",
  "жилетка": "Стиль",
  "худі": "Стиль",
  "шкарпетки": "Стиль",
  "легінси": "Стиль",
  "піжама": "Стиль",
  "труси": "Стиль",
  "білизна": "Стиль",
  "плавки": "Стиль",
  "купальник": "Стиль",
  "рюкзак": "Стиль",
  "сумка": "Стиль",
  "аксесуари": "Стиль",
  "окуляри": "Стиль",
  "ремінь": "Стиль",
  "годинник": "Стиль",
  "капелюх": "Стиль",
  "кепка": "Стиль",
  "панама": "Стиль",
  "рукавички": "Стиль",
  "шарф": "Стиль",
  "брендовий одяг": "Стиль",
  "модний": "Стиль",
  "стильний": "Стиль",
  "жіночий одяг": "Стиль",
  "чоловічий одяг": "Стиль",
  "унісекс одяг": "Стиль",
  // #endregion

  // #region Активність та спорт
  "спорт": "Активність та спорт",
  "спортивний одяг": "Активність та спорт",
  "спортивне взуття": "Активність та спорт",
  "кросівки": "Активність та спорт",
  "бігові кросівки": "Активність та спорт",
  "кеди": "Активність та спорт",
  "шорти": "Активність та спорт",
  "майка": "Активність та спорт",
  "лосини": "Активність та спорт",
  "тренажер": "Активність та спорт",
  "бігова доріжка": "Активність та спорт",
  "велотренажер": "Активність та спорт",
  "гантелі": "Активність та спорт",
  "штанга": "Активність та спорт",
  "турнік": "Активність та спорт",
  "скакалка": "Активність та спорт",
  "фітнес": "Активність та спорт",
  "фітнес-браслет": "Активність та спорт",
  "велосипед спорт": "Активність та спорт",
  "велоформа": "Активність та спорт",
  "теніс": "Активність та спорт",
  "ракетка": "Активність та спорт",
  "м’яч": "Активність та спорт",
  "футбол": "Активність та спорт",
  "баскетбол": "Активність та спорт",
  "волейбол": "Активність та спорт",
  "плавання": "Активність та спорт",
  "плавки спорт": "Активність та спорт",
  "намет": "Активність та спорт",
  "рюкзак туристичний": "Активність та спорт",
  "каска": "Активність та спорт",
  "захист": "Активність та спорт",
  "спортивне спорядження": "Активність та спорт",
  // #endregion

  // #region Б’юті
  "б’юті": "Б’юті",
  "краса": "Б’юті",
  "здоровʼя краса": "Б’юті",
  "косметика": "Б’юті",
  "макіяж": "Б’юті",
  "туш": "Б’юті",
  "помада": "Б’юті",
  "тональний крем": "Б’юті",
  "бронзер": "Б’юті",
  "пудра": "Б’юті",
  "крем": "Б’юті",
  "маска для обличчя": "Б’юті",
  "скраб": "Б’юті",
  "догляд": "Б’юті",
  "догляд за шкірою": "Б’юті",
  "догляд за волоссям": "Б’юті",
  "шампунь": "Б’юті",
  "кондиціонер": "Б’юті",
  "фарба для волосся": "Б’юті",
  "гель лак": "Б’юті",
  "гел-лак": "Б’юті",
  "лампа для нігтів": "Б’юті",
  "епілятор": "Б’юті",
  "медична косметика": "Б’юті",
  "тонометр бʼюті": "Б’юті",
  "термометр бʼюті": "Б’юті",
  "масажер краса": "Б’юті",
  "фітотерапія": "Б’юті",
  "бади": "Б’юті",
  "зубна щітка": "Б’юті",
  "електрощітка": "Б’юті",
  "гігієна": "Б’юті",
  // #endregion

  // #region Знання та Навчання
  "книги та навчання": "Знання та Навчання",
  "книга": "Знання та Навчання",
  "підручник": "Знання та Навчання",
  "навчання": "Знання та Навчання",
  "навчальний курс": "Знання та Навчання",
  "курс": "Знання та Навчання",
  "лекції": "Знання та Навчання",
  "тест": "Знання та Навчання",
  "аудіокнига": "Знання та Навчання",
  "електронна книга": "Знання та Навчання",
  "читанка": "Знання та Навчання",
  "словник": "Знання та Навчання",
  "підготовка": "Знання та Навчання",
  "зно": "Знання та Навчання",
  "математика": "Знання та Навчання",
  "англійська": "Знання та Навчання",
  "українська мова": "Знання та Навчання",
  "історія": "Знання та Навчання",
  "географія": "Знання та Навчання",
  "фізика": "Знання та Навчання",
  // #endregion

    // #region Оренда та прокат
  "оренда": "Оренда та прокат",
  "здам в оренду": "Оренда та прокат",
  "здається": "Оренда та прокат",
  "здам квартиру": "Оренда та прокат",
  "оренда квартири": "Оренда та прокат",
  "оренда житла": "Оренда та прокат",
  "оренда авто": "Оренда та прокат",
  "прокат авто": "Оренда та прокат",
  "прокат": "Оренда та прокат",
  "оренда інструментів": "Оренда та прокат",
  "прокат інструментів": "Оренда та прокат",
  "оренда велосипедів": "Оренда та прокат",
  "прокат велосипедів": "Оренда та прокат",
  "оренда одягу": "Оренда та прокат",
  "прокат одягу": "Оренда та прокат",
  "оренда костюмів": "Оренда та прокат",
  "оренда суконь": "Оренда та прокат",
  // #endregion

  // #region Запчастини та аксесуари (для авто)
  "запчастини": "Запчастини та аксесуари",
  "автозапчастини": "Запчастини та аксесуари",
  "шини": "Запчастини та аксесуари",
  "колеса": "Запчастини та аксесуари",
  "диски": "Запчастини та аксесуари",
  "акумулятор": "Запчастини та аксесуари",
  "масло": "Запчастини та аксесуари",
  "фільтр": "Запчастини та аксесуари",
  "гальмівні колодки": "Запчастини та аксесуари",
  "амортизатори": "Запчастини та аксесуари",
  "бампер": "Запчастини та аксесуари",
  "дзеркала авто": "Запчастини та аксесуари",
  "оптика": "Запчастини та аксесуари",
  "фари": "Запчастини та аксесуари",
  "магнітола": "Запчастини та аксесуари",
  "автокрісла": "Запчастини та аксесуари",
  "чохли авто": "Запчастини та аксесуари",
  "тюнінг": "Запчастини та аксесуари",
  // #endregion

  // #region Аксесуари (мода/стиль)
  "аксесуари": "Аксесуари",
  "окуляри": "Аксесуари",
  "сонцезахисні окуляри": "Аксесуари",
  "годинник": "Аксесуари",
  "браслет": "Аксесуари",
  "ланцюжок": "Аксесуари",
  "цепочка": "Аксесуари",
  "сережки": "Аксесуари",
  "кільце": "Аксесуари",
  "перстень": "Аксесуари",
  "ремінь": "Аксесуари",
  "сумка": "Аксесуари",
  "рюкзак": "Аксесуари",
  "гаманці": "Аксесуари",
  "портмоне": "Аксесуари",
  "шарф": "Аксесуари",
  "рукавички": "Аксесуари",
  "капелюх": "Аксесуари",
  "кепка": "Аксесуари",
  "панама": "Аксесуари",
  // #endregion

  // #region Продукти та їжа
  "продукти": "Продукти та їжа",
  "їжа": "Продукти та їжа",
  "харчі": "Продукти та їжа",
  "харчування": "Продукти та їжа",
  "готова їжа": "Продукти та їжа",
  "домашня їжа": "Продукти та їжа",
  "фастфуд": "Продукти та їжа",
  "піца": "Продукти та їжа",
  "бургери": "Продукти та їжа",
  "суші": "Продукти та їжа",
  "мʼясо": "Продукти та їжа",
  "риба": "Продукти та їжа",
  "овочі": "Продукти та їжа",
  "фрукти": "Продукти та їжа",
  "хліб": "Продукти та їжа",
  "випічка": "Продукти та їжа",
  "молочні продукти": "Продукти та їжа",
  "сир": "Продукти та їжа",
  "йогурт": "Продукти та їжа",
  "молоко": "Продукти та їжа",
  "крупи": "Продукти та їжа",
  "бакалія": "Продукти та їжа",
  "напої": "Продукти та їжа",
  "кава": "Продукти та їжа",
  "чай": "Продукти та їжа",
  "соки": "Продукти та їжа",
  "алкоголь": "Продукти та їжа",
  "вино": "Продукти та їжа",
  "пиво": "Продукти та їжа",
  "солодощі": "Продукти та їжа",
  "шоколад": "Продукти та їжа",
  "торт": "Продукти та їжа",
  "цукерки": "Продукти та їжа",
  // #endregion


};


